const AbiMidApiUrls = {
  LIST: `${process.env.REACT_APP_USER_ABI_URL}/abi/mid/list`,
  CREATE: `${process.env.REACT_APP_USER_ABI_URL}/abi/mid/create`,
  UPDATE: `${process.env.REACT_APP_USER_ABI_URL}/abi/mid/update`,
  GET: `${process.env.REACT_APP_USER_ABI_URL}/abi/mid/get`,
  STATUS_GET: `${process.env.REACT_APP_USER_ABI_URL}/abi/mid/status/get`,
  ARCHIVE: `${process.env.REACT_APP_USER_ABI_URL}/abi/mid/archive`,
  UNARCHIVE: `${process.env.REACT_APP_USER_ABI_URL}/abi/mid/unarchive`,
}

export default AbiMidApiUrls
